// The telemetry register an IO mapping reads from — the name its value is stored under in live
// data, which is what an asset's io_point_name must hold for Live Monitor, alerts, automations and
// history to find it. A mapping's io_point_name is its display name ("Main Pump Status"); only on
// older mappings, and on Generic MQTT ones (stored under io_point_name), is that also the register.
//   - output with a readback → the readback name (OUT1 writes, output-1 reports)
//   - Generic MQTT (json_path) → io_point_name
//   - a bare number as address → io_point_name. The WT-460M default mappings created at gateway
//     registration (uhal.py WT460M_DEFAULT_IO_MAPPINGS) carry the Modbus index there ("1",
//     "124") while the data arrives under the name ("main-pump-di-1", "ch124"); linking to the
//     index left TATA's UNDERGROUND TANK with no live data on 2026-10-13.
//   - everything else → io_point_address ("main-pump-di-1", "ch123")
export function mappingRegister(m) {
  if (!m) return "";
  if (m.readback_io_point_name) return m.readback_io_point_name;
  if (m.json_path) return m.io_point_name || "";
  const addr = String(m.io_point_address ?? "").trim();
  if (/^\d+$/.test(addr) && m.io_point_name) return m.io_point_name;
  return addr || m.io_point_name || "";
}

// "gateway:register" → mapping, also keyed by display name so assets linked by name before the
// register fix still resolve.
export function indexMappings(mappings, gatewayId) {
  const map = {};
  for (const m of mappings || []) {
    const gw = gatewayId || m.gateway_id;
    if (m.io_point_name) map[`${gw}:${m.io_point_name}`] = m;
    const reg = mappingRegister(m);
    if (reg) map[`${gw}:${reg}`] = m;
  }
  return map;
}
